import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { Configuration } from '../_models/configuration';
import { AppConfig } from 'src/assets/config/config/app-config';
@Injectable({ providedIn: 'root' })
export class ConfigurationService {
    apiUrl: string
    captureApiUrl: string
    constructor(private http: HttpClient,
        private config: AppConfig) {
        this.apiUrl = this.config.getConfig('apiUrl')
        this.captureApiUrl = this.config.getConfig('captureApiUrl')
    }

    getConfiguration(): Observable<Configuration[]> {
        return this.http.get<Configuration[]>(this.apiUrl + `/settings/get`);
    }

    addConfiguration(): Observable<Configuration[]> {
        return this.http.get<Configuration[]>(this.apiUrl + `/settings/add`);
    }

    editConfiguration(req): Observable<Configuration[]> { 
      
        return this.http.put<any>(this.apiUrl + `/settings/edit`, req)
            .pipe()
    }
}